<template>
<div class="flowmap-wrapper" style="overflow-x: auto">
  <div class="default-layout layout-another">
    <div class="row row-full">
      <div class="flowmap-box" style="width: 30%;">
        <div class="flowmap-header">
          InterConnect / GCS
        </div>
        <div class="flowmap-content">
          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">평균 지연 요청(CR)</span>
                <span class="num">{{ convertPerfData("OR_GCS/GCS_CONSISTENT_READS_CR") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">평균 지연 요청(현재)</span>
                <span class="num">{{ convertPerfData("OR_GCS/GCS_CONSISTENT_READS_CUR") }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="flowmap-box" style="width: 70%;">
        <div class="flowmap-header">
          Global Database
        </div>
        <div class="flowmap-content flowmap-content-another">
          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">현재 세션 수</span>
                <span class="num">{{ convertPerfData("OR_RAC/RAC_INSTANCE_SESSION_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">액티브 세션 수</span>
                <span class="num">{{ convertPerfData("SESS/DB_SESS_ACTIVE_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">세션 논리 읽기 수</span>
                <span class="num">{{ convertPerfData("OR_SYSSTAT/DBOR_SESS_LOGICAL_READ_COUNT") }}</span>
              </div>
            </li>
          </ul>

          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">버퍼 캐시 적중률</span>
              </div>
              <w-rsc-perf-event-progress-bar :perfRecords="racData" perfKey="MEMSTAT/DB_BUF_CACHE_HITRATIO" :eventTriangle="true" />
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">세션 사용 시간</span>
                <span class="num">{{ convertPerfData("SESS/DB_SESS_CPU_TIME") }}</span>
              </div>
            </li>
          </ul>

          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">라이브러리 캐시 적중률</span>
              </div>
              <w-rsc-perf-event-progress-bar :perfRecords="racData" perfKey="OR_MEMSTAT/DBOR_SGA_LIB_CACHE_HITRATIO" :eventTriangle="true" />
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">딕셔너리 캐시 적중률</span>
              </div>
              <w-rsc-perf-event-progress-bar :perfRecords="racData" perfKey="OR_MEMSTAT/DBOR_SGA_DIC_CACHE_HITRATIO"  :eventTriangle="true"/>
            </li>
          </ul>

          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">메모리/디스크 정렬 비율</span>
              </div>
              <w-rsc-perf-event-progress-bar :perfRecords="racData" perfKey="OR_MEMSTAT/DBOR_SORT_RATE" :eventTriangle="true" />
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">LOCK 사용률</span>
              </div>
              <w-rsc-perf-event-progress-bar :perfRecords="racData" perfKey="LOCK/DB_LOCK_USERATE" :eventTriangle="true" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="default-layout type03-layout">
    <div class="col row-full">
      <div class="flowmap-box" style="width: 220px;">
        <div class="flowmap-header thema-dark">
          Instances
        </div>
        <div class="flowmap-content">
          <ul class="flowmap-list is-border">
            <li>
              <div class="txt-area">
                <span class="txt">CR 블록 전송 수</span>
                <span class="num">{{ convertPerfData("OR_RAC/RAC_INSTANCE_CRBLOCK_SUM") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">Busy 발생 수</span>
                <span class="num">{{ convertPerfData("OR_RAC/RAC_INSTANCE_CR_BUSY_SUM") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">정체 발생 수</span>
                <span class="num">{{ convertPerfData("OR_RAC/RAC_INSTANCE_CR_CONGESTED_SUM") }}</span>
              </div>
            </li>
          </ul>

          <ul class="flowmap-list is-border">
            <li>
              <div class="txt-area">
                <span class="txt">현재 블록 전송 수</span>
                <span class="num">{{ convertPerfData("OR_RAC/RAC_INSTANCE_CURRENT_BLOCK_SUM") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">Busy 발생 수</span>
                <span class="num">{{ convertPerfData("OR_RAC/RAC_INSTANCE_CURRENT_BUSY_SUM") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">정체 발생 수</span>
                <span class="num">{{ convertPerfData("OR_RAC/RAC_INSTANCE_CURRENT_CONGESTED_SUM") }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col row-full arrow-space" style="opacity: 0.5;"> <!-- opacity 처리 필요 -->
      <div class="flowmap-box" v-for="(count, idx) in 6" :key="count">
        <div class="arrow-wrap arrow-top">
          <div class="arrow pink"></div>
        </div>

        <div class="arrow-wrap arrow-top">
          <div class="arrow grey"></div>
        </div>

        <div class="arrow-wrap arrow-top arrow-bottom">
          <div class="arrow pink"></div>
        </div>

        <div class="arrow-wrap arrow-top arrow-bottom">
          <div class="arrow grey"></div>
        </div>

        <div class="flowmap-header">
          Instance
        </div>
        <div class="flowmap-content">
          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">상태</span>
                <span class="num">{{ convertPerfData(`OR_RAC/RAC_INSTANCE_STATUS/${rscKeys[idx]}`) }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">세션 수</span>
                <span class="num">{{ convertPerfData(`OR_RAC/RAC_INSTANCE_SESSION_COUNT/${rscKeys[idx]}`) }}</span>
              </div>
            </li>
          </ul>

          <ul class="flowmap-list is-border">
            <li>
              <div class="txt-area">
                <span class="txt">CR 블록 전송 수</span>
                <span class="num">{{ convertPerfData(`OR_RAC/RAC_INSTANCE_CRBLOCK/${rscKeys[idx]}`) }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">Busy 발생 수</span>
                <span class="num">{{ convertPerfData(`OR_RAC/RAC_INSTANCE_CR_BUSY/${rscKeys[idx]}`) }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">정체 발생 수</span>
                <span class="num">{{ convertPerfData(`OR_RAC/RAC_INSTANCE_CR_CONGESTED/${rscKeys[idx]}`) }}</span>
              </div>
            </li>
          </ul>

          <ul class="flowmap-list is-border">
            <li>
              <div class="txt-area">
                <span class="txt">현재 블록 전송 수</span>
                <span class="num">{{ convertPerfData(`OR_RAC/RAC_INSTANCE_CURRENT_BLOCK/${rscKeys[idx]}`) }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">Busy 발생 수</span>
                <span class="num">{{ convertPerfData(`OR_RAC/RAC_INSTANCE_CURRENT_BUSY/${rscKeys[idx]}`) }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">정체 발생 수</span>
                <span class="num">{{ convertPerfData(`OR_RAC/RAC_INSTANCE_CURRENT_CONGESTED/${rscKeys[idx]}`) }}</span>
              </div>
            </li>
          </ul>

          <ul class="flowmap-list is-border">
            <li>
              <div class="txt-area">
                <span class="txt">기동 시각</span>
                <span class="num">{{ convertPerfData(`OR_RAC/RAC_INSTANCE_STARTUP_TIME/${rscKeys[idx]}`) }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="default-layout layout-another">
    <div class="row row-full col-full">
      <div class="flowmap-box">
        <div class="flowmap-header">
          ASM
        </div>
        <div class="flowmap-content">
          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">연결</span>
                <span class="num">{{ convertPerfData("OR_ASM_STAT_DISK_GROUP/ASM_DISK_GROUP_CON_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">연결 종료</span>
                <span class="num">{{ convertPerfData("OR_ASM_STAT_DISK_GROUP/ASM_DISK_GROUP_BRK_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">알 수 없음</span>
                <span class="num">{{ convertPerfData("OR_ASM_STAT_DISK_GROUP/ASM_DISK_GROUP_UKN_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">디스크 그룹 전체 크기</span>
                <span class="num">{{ convertPerfData("OR_ASM_STAT_DISK_GROUP/ASM_DISK_GROUP_TOTSIZE") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">사용률</span>
              </div>
              <w-rsc-perf-event-progress-bar :perfRecords="racData" perfKey="OR_ASM_STAT_DISK_GROUP/ASM_DISK_GROUP_TOTUSERATE" :eventTriangle="true" />
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">사용량</span>
                <span class="num">{{ convertPerfData("OR_ASM_STAT_DISK_GROUP/ASM_DISK_GROUP_TOTUSEDSIZE") }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="flowmap-box">
        <div class="flowmap-header">
          Data FilesM
        </div>
        <div class="flowmap-content">
          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">전체 크기</span>
                <span class="num">{{ convertPerfData("TABLESPACE/DB_TABLESPACE_TOTSIZE") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">사용률</span>
              </div>
              <w-rsc-perf-event-progress-bar :perfRecords="racData" perfKey="TABLESPACE/DB_TABLESPACE_USERATE" :eventTriangle="true" />
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">사용량</span>
                <span class="num">{{ convertPerfData("TABLESPACE/DB_TABLESPACE_USEDSIZE") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">파일 수</span>
                <span class="num">{{ convertPerfData("OR_STRG/DBOR_ONLINE_FILE_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">테이블 공간 수</span>
                <span class="num">{{ convertPerfData("OR_STRG/DBOR_ONLINE_TS_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">물리 읽기</span>
                <span class="num">{{ convertPerfData("OR_SYSSTAT/DBOR_PHYSICAL_READ_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">물리 쓰기</span>
                <span class="num">{{ convertPerfData("OR_SYSSTAT/DBOR_PHYSICAL_WRITE_COUNT") }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="flowmap-box">
        <div class="flowmap-header">
          Redo Logs
        </div>
        <div class="flowmap-content">
          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">Redo Logs 사용률</span>
              </div>
              <w-rsc-perf-event-progress-bar :perfRecords="racData" perfKey="OR_STRG/DBOR_REDOLOGFILE_USERATE" :eventTriangle="true" />
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">사용량</span>
                <span class="num">{{ convertPerfData("OR_STRG/DBOR_REDOLOGFILE_SIZE") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">Redo 블록 쓰기</span>
                <span class="num">{{ convertPerfData("OR_SYSSTAT/DBOR_REDO_BLOCK_WRITE_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">그룹 수</span>
                <span class="num">{{ convertPerfData("OR_STRG/DBOR_REDOLOGFILE_GROUP_COUNT") }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="flowmap-box">
        <div class="flowmap-header">
          Archive Logs
        </div>
        <div class="flowmap-content">
          <ul class="flowmap-list">
            <li>
              <div class="txt-area">
                <span class="txt">사용량</span>
                <span class="num">{{ convertPerfData("OR_SYSSTAT/DBOR_ARCHIVELOG_TOTAL_SIZE") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">Archive 쓰기</span>
                <span class="num">{{ convertPerfData("OR_SYSSTAT/DBOR_ARCHIVELOG_WRITE_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">도착지 수</span>
                <span class="num">{{ convertPerfData("OR_STRG/DBOR_ARCHIVELOG_DEST_COUNT") }}</span>
              </div>
            </li>
            <li>
              <div class="txt-area">
                <span class="txt">File System 수</span>
                <span class="num">{{ convertPerfData("OR_STRG/DBOR_ARCHIVELOG_DISK_COUNT") }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import union from 'lodash/union';

import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { getIntervalDatetimeParams, getRequestDatetimeParams } from '@/utils/date';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';
import DatabaseAPI from '@/api/performance/database/database-table-info';

export default {
  name: 'WOracleRac',
  components: { WRscPerfEventProgressBar },
  data() {
    return {
      rscInfoList: [
        { rsctypeId: 'OR_GCS', rscId: 'GCS_CONSISTENT_READS_CR', rscKey: '_' },
        { rsctypeId: 'OR_GCS', rscId: 'GCS_CONSISTENT_READS_CUR', rscKey: '_' },
        { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_SESSION_COUNT', rscKey: '_' },
        { rsctypeId: 'SESS', rscId: 'DB_SESS_ACTIVE_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_SYSSTAT', rscId: 'DBOR_SESS_LOGICAL_READ_COUNT', rscKey: '_' },
        { rsctypeId: 'MEMSTAT', rscId: 'DB_BUF_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'SESS', rscId: 'DB_SESS_CPU_TIME', rscKey: '_' },
        { rsctypeId: 'OR_MEMSTAT', rscId: 'DBOR_SGA_LIB_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'OR_MEMSTAT', rscId: 'DBOR_SGA_DIC_CACHE_HITRATIO', rscKey: '_' },
        { rsctypeId: 'OR_MEMSTAT', rscId: 'DBOR_SORT_RATE', rscKey: '_' },
        { rsctypeId: 'LOCK', rscId: 'DB_LOCK_USERATE', rscKey: '_' },
        { rsctypeId: 'OR_ASM_STAT_DISK_GROUP', rscId: 'ASM_DISK_GROUP_CON_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_ASM_STAT_DISK_GROUP', rscId: 'ASM_DISK_GROUP_BRK_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_ASM_STAT_DISK_GROUP', rscId: 'ASM_DISK_GROUP_UKN_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_ASM_STAT_DISK_GROUP', rscId: 'ASM_DISK_GROUP_TOTSIZE', rscKey: '_' },
        { rsctypeId: 'OR_ASM_STAT_DISK_GROUP', rscId: 'ASM_DISK_GROUP_TOTUSERATE', rscKey: '_' },
        { rsctypeId: 'OR_ASM_STAT_DISK_GROUP', rscId: 'ASM_DISK_GROUP_TOTUSEDSIZE', rscKey: '_' },
        { rsctypeId: 'TABLESPACE', rscId: 'DB_TABLESPACE_TOTSIZE', rscKey: '_' },
        { rsctypeId: 'TABLESPACE', rscId: 'DB_TABLESPACE_USERATE', rscKey: '_' },
        { rsctypeId: 'TABLESPACE', rscId: 'DB_TABLESPACE_USEDSIZE', rscKey: '_' },
        { rsctypeId: 'OR_STRG', rscId: 'DBOR_ONLINE_FILE_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_STRG', rscId: 'DBOR_ONLINE_TS_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_SYSSTAT', rscId: 'DBOR_PHYSICAL_READ_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_SYSSTAT', rscId: 'DBOR_PHYSICAL_WRITE_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_STRG', rscId: 'DBOR_REDOLOGFILE_USERATE', rscKey: '_' },
        { rsctypeId: 'OR_STRG', rscId: 'DBOR_REDOLOGFILE_SIZE', rscKey: '_' },
        { rsctypeId: 'OR_SYSSTAT', rscId: 'DBOR_REDO_BLOCK_WRITE_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_STRG', rscId: 'DBOR_REDOLOGFILE_GROUP_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_SYSSTAT', rscId: 'DBOR_ARCHIVELOG_TOTAL_SIZE', rscKey: '_' },
        { rsctypeId: 'OR_SYSSTAT', rscId: 'DBOR_ARCHIVELOG_WRITE_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_STRG', rscId: 'DBOR_ARCHIVELOG_DEST_COUNT', rscKey: '_' },
        { rsctypeId: 'OR_STRG', rscId: 'DBOR_ARCHIVELOG_DISK_COUNT', rscKey: '_' },
      ],
      instanceRscInfoList: [],
      rscKeys: [],
      racData: {},
    };
  },
  methods: {
    /**
     * 성능 값 단위 환산을 한다.
     * @param  {[type]} perfKey [description]
     * @return {[type]}         [description]
     * @author jda
     */
    convertPerfData(perfKey) {
      const racData = this.racData;
      const perfData = racData[perfKey];

      if (isNil(perfData)) {
        return EMPTY_TEXT;
      }
      const unit = racData[`${perfKey}/UNIT`];
      return convertValuByUnit(perfData, unit, true);
    },
    /**
     * Instance의 obj_rsc_key를 구한다.
     * @return {[type]} [description]
     * @author jda
     */
    getInstanceRscKey(obj, plotLineDatetime) {
      DatabaseAPI.getObjRscKeyList({
        managetypeId: obj.objManagetypeId,
        objId: obj.objId,
      })
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.rscKeys = result;

            const instanceRscInfoList = [];
            result.forEach((rscKey) => {
              instanceRscInfoList.push(
                { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_STATUS', rscKey },
                { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_SESSION_COUNT', rscKey },
                { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_CRBLOCK', rscKey },
                { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_CR_BUSY', rscKey },
                { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_CR_CONGESTED', rscKey },
                { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_CURRENT_BLOCK', rscKey },
                { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_CURRENT_BUSY', rscKey },
                { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_CURRENT_CONGESTED', rscKey },
                { rsctypeId: 'OR_RAC', rscId: 'RAC_INSTANCE_STARTUP_TIME', rscKey },
              );
            });

            this.instanceRscInfoList = instanceRscInfoList;
          }

          // 성능 값 조회
          this.getOracleRacData(obj, plotLineDatetime);
        })
        .catch(() => {
          // FIXME: 서버 호출 실패시 메시지박스
        });
    },
    /**
     * RAC 성능 정보 및 이벤트를 가져온다.
     * @return {[type]} [description]
     * @author jda
     */
    getOracleRacData(obj, plotLineDatetime) {
      const dateParams = this.getDatetimeParams(this.plotLineDatetime);
      DatabaseAPI.getOracleRacData({
        managetypeId: obj.objManagetypeId,
        objId: obj.objId,
        rscInfoList: union(this.rscInfoList, this.instanceRscInfoList),
        startDatetime: dateParams.startDatetime,
        endDatetime: dateParams.endDatetime,
        checkDatetime: plotLineDatetime,
      })
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;

            // Instance의 블록 전송 수 , Busy 발생 수, 정체 발생 수는 합을 구한다.
            if (!isEmpty(this.rscKeys)) {
              const sumKeys = ['OR_RAC/RAC_INSTANCE_CRBLOCK', 'OR_RAC/RAC_INSTANCE_CR_BUSY', 'OR_RAC/RAC_INSTANCE_CR_CONGESTED', 'OR_RAC/RAC_INSTANCE_CURRENT_BLOCK', 'OR_RAC/RAC_INSTANCE_CURRENT_BUSY', 'OR_RAC/RAC_INSTANCE_CURRENT_CONGESTED'];
              sumKeys.forEach((key) => {
                let sumValue = 0;
                this.rscKeys.forEach((rscKey) => {
                  sumValue += result[`${key}/${rscKey}`];
                });
                result[`${key}_SUM`] = sumValue;
                result[`${key}_SUM/UNIT`] = 'count';
              });
            }
            this.racData = result;
          }
        })
        .catch(() => {
          // FIXME: 서버 호출 실패시 메시지박스
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/OraclePlus/OracleRac.vue